import { render } from "./WRSsFilters.vue?vue&type=template&id=49964c38&scoped=true&ts=true"
import script from "./WRSsFilters.vue?vue&type=script&lang=ts"
export * from "./WRSsFilters.vue?vue&type=script&lang=ts"

import "./WRSsFilters.vue?vue&type=style&index=0&id=49964c38&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49964c38"]])

export default __exports__